console.log('Creating Google Analytics script')
function loadGtag(tagId) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${tagId}`;
    document.head.appendChild(script);
}

window.dataLayer = window.dataLayer || [];
function gtag() {
    window.dataLayer.push(arguments);
}


// API to be used in the application to send events to Google Analytics
const $gtag = {
    postSignUp: function (param) {
        gtag('event', 'ads_conversion_Sign_up_1', param);
    },
    init: function () {
        console.log('Initializing Google Analytics');
        loadGtag('G-CDVLHXVLGM');
        loadGtag('AW-16480991432');
        gtag('js', new Date());
        gtag('config', 'G-CDVLHXVLGM');
        gtag('config', 'AW-16480991432');
        console.log('Google Analytics initialized');
    },
};
console.log('Google Analytics script loaded')


